import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { DISH_TYPE_NODE_FRAGMENT } from '../fragments'

const DELETE_DISH_TYPE_MUTATION = gql`
  mutation deleteDishType($id: ID!) {
    deleteDishType(id: $id) {
      results {
        ...DishTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${DISH_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default DELETE_DISH_TYPE_MUTATION
